export const adminRoleToLabel = {
    superadmin: 'Super Admin',
    admin: 'Admin',
    readonly: 'Read Only',
};
